import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()(() => ({
  errorInfo: {
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    textAlign: "left"
  }
}));
function ErrorDetails({ error, componentStack }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, error && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { className: classes.errorInfo }, error.message), /* @__PURE__ */ React.createElement(Box, { className: classes.errorInfo }, error.stack)), componentStack && /* @__PURE__ */ React.createElement(Box, { className: classes.errorInfo }, componentStack));
}
export {
  ErrorDetails,
  useClasses
};
//# sourceMappingURL=ErrorDetails.js.map
